import type { Size } from '@/api/models';

interface Props {
  sizes: Size[];
  value: string | null;
  onChange: (slug: string) => void;
  highlight?: boolean;
  shakeRef?: React.Ref<HTMLDivElement>;
}

/** Size picker for the rail's focus view. Sold-out sizes are struck through and disabled. */
export function SizeButtons({ sizes, value, onChange, highlight, shakeRef }: Props) {
  return (
    <div ref={shakeRef} className={'sizes' + (highlight ? ' need' : '')} role="group" aria-label="Size">
      {sizes.map((s) => (
        <button
          key={s.slug}
          type="button"
          disabled={!s.inStock}
          aria-pressed={value === s.slug}
          aria-label={s.inStock ? `Size ${s.name}` : `Size ${s.name}, sold out`}
          onClick={() => onChange(s.slug)}
        >
          {s.name}
        </button>
      ))}
    </div>
  );
}
